import { unstableSetRender } from "antd";
import { createRoot, type Root } from "react-dom/client";

// Ant Design 5 static dialogs/messages need the React 19 createRoot renderer.
const roots = new WeakMap<Element | DocumentFragment, Root>();
unstableSetRender((node, container) => {
  let root = roots.get(container);
  if (!root) {
    root = createRoot(container);
    roots.set(container, root);
  }
  root.render(node);
  const current = root;
  return async () => {
    // Avoid unmounting a root during another React render/commit.
    await new Promise<void>(resolve => setTimeout(resolve, 0));
    current.unmount();
    if (roots.get(container) === current) roots.delete(container);
  };
});
